// NOTE: Payroll Earning Codes Form

export enum PREarnCodeFieldsEnum {
  EarnCode = 1,
  Desc = 5,
  Method = 10,
  Routine = 11,
  Factor = 15,
  SubjAuto = 20,
  SubjAddons = 22,
  CertRpt = 25,
  FringeBenefitCode = 26,
  TrueEarn = 30,
  IncldLiabDist = 31,
  CalcOT = 32,
  IncldSalDist = 33,
  EarnType = 35,
  TrackACAYN = 38,
  PhaseGrp = 39,
  JCCType = 40,
  SuppEarnings = 50,
  StandardLimit = 60,
  LimitType = 65,
  AutoAP = 85,
  APCo = 88,
  VendorGroup = 89,
  Vendor = 90,
  TransByEmploy = 95,
  IncldRemoteTC = 100,
  PayType = 120,
  GLCo = 122,
  GLAcct = 123,
  Freq = 125,
  ATOCategory = 150,
  ATType = 151,
  ATOtherType = 152,
  IncludeInSTPGross = 153,
  InsurableEarnings = 160,
  InsurableHours = 170,
  Separation = 180,
  ROECategory = 190,
  OtherMoniesType = 200,
  VacationType = 205,
  Special = 210,
  ROEType = 220,
  ROEPeriod = 230,
  STP2PayeeGrossIncludeYN = 250,
  STP2RFBAIncludeYN = 260,
  STP2Category = 270,
  STP2AllowanceCode = 280,
  STP2AllowanceOtherCode = 290,
  STP2LSEYear = 300,
}
